import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface BackgroundCheckUserPanelHeaderProps {
    navigateBackTitle: string;
    onNavigateBack: () => void;
    backgroundCheckType?: BackgroundCheckType;
}

export const BackgroundCheckUserPanelHeader: React.FC<BackgroundCheckUserPanelHeaderProps> = ({
    navigateBackTitle,
    onNavigateBack,
    backgroundCheckType,
}) => {
    const { t } = useTranslation();

    return (
        <PageHeaderWithImage
            gradient='cyan-light'
            title={
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
                    <Button variant='text' color='inherit' startIcon={<ArrowBackIcon />} onClick={onNavigateBack} data-test='back-button'>
                        {navigateBackTitle}
                    </Button>
                    <Typography variant='h4'>
                        {backgroundCheckType ? `${t(`pages.screenings.backgroundChecks.${backgroundCheckType}`)} ` : ''}
                        {t('pages.screenings.backgroundChecks.title')}
                    </Typography>
                </Box>
            }
        />
    );
};
